import React from "react";

const SiteStartupScreen = ({ status = "loading", onRetry }) => {
  const isError = status === "error";

  return (
    <div
      data-site-startup-screen={isError ? "error" : "loading"}
      className="min-h-screen bg-slate-50 text-slate-900"
    >
      <div className="mx-auto flex min-h-screen w-full max-w-7xl flex-col">
        <header className="h-20 shrink-0 border-b border-slate-200 bg-white" aria-label="Loading site header">
          <div className="h-full animate-pulse px-6 py-5">
            <div className="h-8 w-44 rounded-lg bg-slate-200" />
          </div>
        </header>

        <main className="flex min-h-[calc(100vh-10rem)] flex-1 items-center justify-center px-6 py-12">
          <div className="w-full max-w-xl text-center">
            {isError ? (
              <>
                <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-rose-100 text-2xl text-rose-600">!</div>
                <h1 className="text-2xl font-semibold">This site is unavailable</h1>
                <p className="mt-3 text-sm leading-6 text-slate-600">
                  We could not resolve the current site configuration. Please refresh or contact the site administrator.
                </p>
                {onRetry && (
                  <button
                    type="button"
                    onClick={onRetry}
                    className="mt-6 rounded-xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white"
                  >
                    Try again
                  </button>
                )}
              </>
            ) : (
              <>
                <div className="mx-auto mb-6 h-3 w-40 animate-pulse rounded-full bg-slate-200" />
                <div className="mx-auto h-4 w-72 animate-pulse rounded-full bg-slate-200" />
                <div className="mx-auto mt-3 h-4 w-56 animate-pulse rounded-full bg-slate-200" />
                <p className="mt-8 text-sm text-slate-500">Loading site configuration…</p>
              </>
            )}
          </div>
        </main>

        <footer className="h-20 shrink-0 border-t border-slate-200 bg-white" aria-label="Loading site footer" />
      </div>
    </div>
  );
};

export default SiteStartupScreen;

